import { render, staticRenderFns } from "./SearchResultTabsAttractionsList.vue?vue&type=template&id=3d16dfc2&"
import script from "./SearchResultTabsAttractionsList.vue?vue&type=script&lang=js&"
export * from "./SearchResultTabsAttractionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListItem})
